import React from 'react'
import type { OnSubmit, OnSubmitSuccess } from './types'

export function useOnSubmitSuccess<Values, Result extends Values>(
  submitHandler: OnSubmit<Values, Result>,
  submitSuccessHandler?: OnSubmitSuccess<Values, Result>
): OnSubmit<Values, Result> {
  return React.useCallback(
    async (values, formikHelpers) => {
      const result = await submitHandler(values, formikHelpers)

      if (submitSuccessHandler) {
        submitSuccessHandler(result, formikHelpers)
      }

      return result
    },
    [submitHandler, submitSuccessHandler]
  )
}
